import { render, staticRenderFns } from "./select-panel.vue?vue&type=template&id=470d1724&"
import script from "./select-panel.vue?vue&type=script&lang=js&"
export * from "./select-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports